import { frontendURL } from 'dashboard/helper/URLHelper';

const TerminationsIndex = () => import('./pages/TerminationsIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/terminations'),
      name: 'terminations_index',
      component: TerminationsIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
